import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SessionService } from '@core/services/session.service';
import { CoinflipDeprecatedService } from '@old-app/coinflip/coinflip.service';
import {
  Coinflip,
  CoinflipSide,
} from '@old-app/coinflip/interfaces/coinflip.interface';
import { ToastrService } from 'ngx-toastr';
import { GameIconComponent } from '../../../../core/components/game-icon/game-icon.component';
import { ModalService } from '@features/modals/services/modal.service';
import { SkinsListComponent } from '../../../../core/components/skins-list/skins-list.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { CoinflipCoinComponent } from '../../../../features/coinflip/coinflip-coin/coinflip-coin.component';
import { CostComponent } from '../../../../core/components/cost/cost.component';
import { ContextMenuService } from '@core/services/context-menu.service';
import { CountdownComponent } from 'ngx-countdown';
import { fadeInAnimation } from '@core/utils/animations.util';
import { sortSkinsByPriceDesc } from '@core/utils/skins.util';

@Component({
  selector: 'app-cf-player-side',
  templateUrl: './cf-player-side.component.html',
  styleUrls: ['./cf-player-side.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    GameIconComponent,
    SkinsListComponent,
    SvgIconComponent,
    CoinflipCoinComponent,
    CostComponent,
    CountdownComponent,
  ],
  animations: [fadeInAnimation]
})
export class CfPlayerSideComponent {
  readonly coinflip = input.required<Coinflip>();
  readonly bet = input<CoinflipSide>();
  readonly isHost = input.required<boolean>();
  readonly showAnimation = input(true);

  filteredSkins = computed(() =>
    sortSkinsByPriceDesc(
      (this.bet()?.skins ?? []).filter((s) => s.is_rake !== 1)
    )
  );

  constructor(
    private modalService: ModalService,
    public session: SessionService,
    private coinflipService: CoinflipDeprecatedService,
    private toastrService: ToastrService,
    public contextMenuService: ContextMenuService
  ) {}

  openJoinModal() {
    this.modalService.openModal('CoinflipDepositModal', {
      coinflip: this.coinflip(),
    });
  }

  async callBot() {
    const res = await this.coinflipService.callBot(this.coinflip());
    if (res) {
      this.toastrService.success(res);
    }
  }
  // cf.end - currentTime;
  async cancelCoinflip(): Promise<void> {
    try {
      await this.coinflipService.cancelCoinflip(this.coinflip());
      this.modalService.close();
    } catch (error) {
      console.error('Error cancelling coinflip:', error);
    }
  }
}
